import { NostrEvent } from '@nostr/tools/core'
import * as kinds from '@nostr/tools/kinds'
import { useTranslation } from 'react-i18next'

export default function Title({
  parentEvents,
  parentExternal
}: {
  parentEvents?: NostrEvent[]
  parentExternal?: string
}) {
  const { t } = useTranslation()

  if (parentEvents && parentEvents.length > 1)
    return (
      <div className="flex gap-2 items-center w-full">
        <div className="shrink-0">{t('Bulk Reply')}</div>
      </div>
    )

  if (parentEvents) {
    const parent = parentEvents[0]
    const isReply =
      parent.kind === kinds.ShortTextNote ||
      (parent.kind === kinds.Comment &&
        parent.tags.some(([name, value]) => name === 'K' && value === '1'))
    return (
      <div className="flex gap-2 items-center w-full">
        <div className="shrink-0">{isReply ? t('Reply to') : t('Comment about')}</div>
      </div>
    )
  }

  if (parentExternal)
    return (
      <div className="flex gap-2 items-center w-full">
        <div className="shrink-0">{t('Comment on')}</div>
      </div>
    )

  return (
    <div className="flex gap-2 items-center w-full">
      <div className="shrink-0">{t('New Note')}</div>
    </div>
  )
}
